import React from 'react';

function UploadFileField(props) {
    return (
        <div></div>
    );
}

export default UploadFileField;